import { ErrorHandler } from '@angular/core';
import { FirebaseError } from '@angular/fire/app';

export class GlobalErrorHandler extends ErrorHandler {
  override handleError(error: any) {
    if (error instanceof FirebaseError) return this.handleFirebaseError(error);

    super.handleError(error);
  }

  private handleFirebaseError(error: FirebaseError) {
    alert(error);
  }
}
